import { render, staticRenderFns } from "./NoInformation.vue?vue&type=template&id=01d15594"
import script from "./NoInformation.vue?vue&type=script&lang=js"
export * from "./NoInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports